// Paged, realtime-subscribed rows for one external Supabase table.
// Click a row to open RemoteRowEditor (update mode).

export const RemoteRowTr = {
  tag: 'tr',
  cursor: 'pointer',
  ':hover': { background: 'hover' },
  onClick: (e, el, s) => {
    const { slug, table } = el.call('parseRemotePath')
    const schema = el.call('schemaForRemoteTable', s.root, slug, table)
    const values = {}
    for (const c of schema?.columns || []) {
      const v = s.__row?.[c.name]
      values[c.name] = v == null ? '' : typeof v === 'object' ? JSON.stringify(v) : String(v)
    }
    s.root.update({
      _extEditor: {
        mode: 'update',
        slug,
        table,
        values,
        original: s.__row
      }
    })
  },
  childExtends: {
    tag: 'td',
    padding: 'Z',
    borderBottomWidth: 'hairline',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    fontSize: 'Y2',
    color: 'title',
    fontFamily: 'mono',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '320px',
    text: (el, s) => {
      const v = s.value
      if (v == null) return ''
      if (typeof v === 'string') return v
      if (typeof v === 'object') return JSON.stringify(v)
      return String(v)
    }
  },
  childrenAs: 'state',
  children: (el, s) => {
    const row = s.__row || {}
    return (s.__cols || []).map((c) => ({ name: c.name, value: row[c.name] }))
  }
}

export const RemoteRowTable = {
  overflow: 'auto',
  round: 'radiusControl',
  // Fill-contrast card (was a `line` border redundant on top of this same
  // `overlay` fill — border-habit sweep, design-direction.md §8). The inner
  // `<td>`/`<th>` dividers below are KEPT — dense-data-table exception,
  // §2.5, same as MembersTable.
  background: 'overlay',

  Inner: {
    tag: 'table',
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 'Y2',

    Head: {
      tag: 'thead',
      background: 'overlayStrong',
      Row: {
        tag: 'tr',
        childExtends: {
          tag: 'th',
          padding: 'Z',
          textAlign: 'left',
          color: 'caption',
          fontWeight: '700',
          letterSpacing: '.04em',
          textTransform: 'uppercase',
          fontSize: 'Y1',
          borderBottomWidth: 'hairline',
          borderBottomStyle: 'solid',
          borderBottomColor: 'line',
          whiteSpace: 'nowrap',
          text: (el, s) => s.name
        },
        childrenAs: 'state',
        children: (el, s) => {
          const { slug, table } = el.call('parseRemotePath')
          if (!slug || !table) return []
          const schema = el.call('schemaForRemoteTable', s.root, slug, table)
          return schema?.columns || []
        }
      }
    },

    Body: {
      tag: 'tbody',
      childExtends: 'RemoteRowTr',
      childrenAs: 'state',
      children: (el, s) => {
        const rows = s.root?._extRows || []
        const { slug, table } = el.call('parseRemotePath')
        const schema = el.call('schemaForRemoteTable', s.root, slug, table)
        const cols = schema?.columns || []
        return rows.map((r, idx) => ({ __row: r, __idx: idx, __cols: cols }))
      }
    }
  }
}
